import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { breakpoints } from '@/shared/styles';
import { LinkButton } from '@/shared/components/LinkButton';

import article1Cover from './images/article_1.svg';
import article2Cover from './images/article_2.svg';
import article3Cover from './images/article_3.svg';

const Container = styled.section`
  display: flex;
  flex-direction: column;
  gap: 40px;
  font-family: Gramatika;

  padding: 0 20px;
  margin-top: 60px;

  @media (min-width: ${breakpoints.tabletSM}px) {
    padding: 0 16px;
    margin-top: 180px;
  }

  @media (min-width: ${breakpoints.laptopSM}px) {
    padding: 0;
  }

  .Articles__header_mobile {
    display: block;

    @media (min-width: ${breakpoints.tabletSM}px) {
      display: none;
    }
  }

  .Articles__header_desktop {
    display: none;

    @media (min-width: ${breakpoints.tabletSM}px) {
      display: block;
    }
  }

  .Articles__container {
    display: grid;
    grid-template-columns: 1fr;
    gap: 24px;

    @media (min-width: ${breakpoints.tabletSM}px) {
      grid-template-columns: 1fr 1fr 1fr;
    }
  }

  .Articles__header_container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
`;

const ArticleContainer = styled(Link)`
  color: #fff;
  text-decoration: none;
  border: 1px solid #1f2028;
  background: #18191f;
  border-radius: 32px;
  display: flex;
  flex-direction: column;

  &:hover {
    text-decoration: underline;
  }

  @media (min-width: ${breakpoints.tabletSM}px) {
    border-radius: 56px;
  }

  .Article__title_container {
    padding: 24px;
    font-family: Gramatika;
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;

    @media (min-width: ${breakpoints.tabletSM}px) {
      padding: 32px;
      font-size: 21px;
      line-height: 29.4px;
    }
  }

  .Article__image_container {
    min-height: 200px;
    height: 200px;
    width: 100%;
    padding: 19px;

    & img {
      background: #282a33;
      overflow: hidden;
      border-radius: 32px;
      object-fit: cover;
    }
  }
`;

type Article = {
  title: string;
  href: string;
  imgSrc: string;
  imgAlt: string;
};

const articles: Article[] = [
  {
    title: 'Mellow Vision for Permissionless Onchain Structured Products',
    href: 'https://mellowprotocol.substack.com/p/mellow-vision-for-permissionless',
    imgSrc: article1Cover,
    imgAlt: 'Mellow cover',
  },

  {
    title: 'How we can help decentralize Ethereum with solo staking vaults. Meet DVstETH',
    href: 'https://mellowprotocol.substack.com/p/how-we-can-help-decentralize-ethereum',
    imgSrc: article2Cover,
    imgAlt: 'DVstETH',
  },
  {
    title: 'Aggregation & Isolation of Risks in Restaking Markets',
    href: 'https://mellowprotocol.substack.com/p/aggregation-and-isolation-of-risks',
    imgSrc: article3Cover,
    imgAlt: 'Aggregation & Isolation',
  },
];

export const Articles = () => (
  <Container>
    <div className="Articles__header_container">
      <h2 className="Articles__header_mobile">Articles</h2>
      <h2 className="Articles__header_desktop">Updates & Research</h2>
      <LinkButton variant="primary" to="https://mellowprotocol.substack.com" target="_blank">
        All publications
      </LinkButton>
    </div>

    <div className="Articles__container">
      {articles.map((article, idx) => (
        <ArticleContainer key={`article_${idx}`} target="_blank" to={article.href}>
          <div className="Article__image_container">
            <img
              width="100%"
              height="100%"
              loading="lazy"
              alt={article.imgAlt}
              src={article.imgSrc}
            />
          </div>
          <div className="Article__title_container">{article.title}</div>
        </ArticleContainer>
      ))}
    </div>
  </Container>
);
